export default __webpack_public_path__ + "static/media/i080sk.142d609f.webp";